

export default [
  {name: 'index', path: '/'/*, component: pg_index*/},

];
